/** @format */

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import HomePageView from './homePage/HomePageView';
import { BlogPageView } from './blogPage/BlogPageView';
import ErrorPage from './errorPage/ErrorPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePageView />} />
        <Route path="/blogs/:id" element={<BlogPageView />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}
